import { launchPanelApp } from './lib/PanelApp';
import PreLoginLayout from './pages/layout/PreLoginLayout';

// Page specific code :
import Support from './pages/support/Support';

launchPanelApp(Support, {}, PreLoginLayout);
